import { useEffect, useState } from 'react';
import useNewItemChange from '../../../../../../../../../EHR/EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import { Separator } from '../../../../../../../../../EHR/utils/utils';
import ShowItemContent from './ShowItemContent';

const Table = ({ item, setItem, activeAccordion, validations, isGroupNote, ...props }) => {
    //   let activeAccordion = 'Intake Form';
    const { handleChangeHeader, handleChangeRows, handleAddRow, handleDeleteRow } = useNewItemChange(setItem, 'Viewer', activeAccordion);
    const headers = item.headers ? item.headers.split(Separator) : [];
    const rows = item.rows ?
        item.rows?.split("\n") ? item.rows?.split("\n") : item.rows?.split("\n") :
        [];
    const rowCount = Number(item.noOfRows) || rows.length || 1;
    console.log("EncounterTable", item)
    // useEffect(() => {
    //     if (JSON.stringify(rows) === JSON.stringify(item.rows)) {
    //         return; // No change, so exit early
    //     }
    //     setItem(prev => {
    //         return prev.map(section => {
    //             if (section.key === activeAccordion) {
    //                 const updatedItems = section.items.map(currItem => {
    //                     if (currItem.ItemID === item.ItemID) {
    //                         let defaultRows = '';
    //                         Array.from({ length: item.noOfRows || 0 }).forEach((_, index, arr) => {
    //                             defaultRows += Array.from({ length: item.noOfHeaders - 1 || 0 }).map(() => ',').join('');
    //                             if (index < arr.length - 1) defaultRows += '\n'; // Only add '\n' if it's NOT the last row
    //                         });
    //                         return { ...currItem, rows: defaultRows };
    //                     }
    //                     return currItem;
    //                 });
    //                 return { ...section, items: updatedItems };
    //             }
    //             return section;
    //         });
    //     });
    // }, [])

    return (
        <div className="ar-content-box d-flex flex-column gap-2">
            <div className="d-flex gap-10">
                <div className="ar-form-counter flex-center">
                    <p className='text text-black'>{props?.itemCount}</p>
                </div>
                <div className='table-view template-acordian d-flex flex-column gap-6 min-w-0'>
                    <p className={`heading fs-13 d-flex gap-01 ${validations?.isInvalid ? 'Denied-clr' : ''}`}>
                        {/* {item?.content || "[Enter prompt or question]"} */}
                        {ShowItemContent(item, isGroupNote)}
                        {/* \\ Required icon commented \\ */}
                        {/* {[true, "true"].includes(item?.isRequired) ? <span className="text font-m Denied-clr fs-14">*</span> : <></>} */}
                    </p>
                    <div className="overflow-auto">
                        <table className='templates-table output' >
                            <thead>
                                <tr>
                                    {headers.length > 0 ?
                                        (headers.map((header, index) => (
                                            <th key={index} className='font-m fw-500 text w-auto'>
                                                {header || `[Insert Column Header ${index + 1}]`}
                                            </th>
                                        ))) : <th className='font-m fw-500 text w-auto'>[Insert Column Header 1]</th>}
                                    {rowCount > 1 && (<th className="min-w-0"></th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {Array.from({ length: item.noOfRows || 2 }).map((_, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {console.log("TableViewer", rows)}
                                        {(rows?.[rowIndex] || "")?.split(Separator).map((rowItem, cellIndex) => (
                                            <td key={cellIndex}>
                                                <div className="input h-100">
                                                    <input
                                                        type="text"
                                                        value={rowItem}
                                                        onChange={(e) => handleChangeRows(item, e, rowIndex, cellIndex)}
                                                        className='form-control border-0 font-r'
                                                    />
                                                </div>
                                            </td>)
                                        )}
                                        {rowCount > 1 &&
                                            (<td ><i className="icon-delete ar-light-color fs-11" onClick={() => handleDeleteRow(item, rowIndex)}></i></td>)}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex align-items-center gap-6">
                        <button className='btn btn-ar-add px-2' onClick={() => handleAddRow(item)}> <i className="icon-plus-feesetup theme-clr fs-9"></i> Add Row</button>
                    </div>
                </div >
            </div >
        </div >
    );
};

export default Table